<template>
  <div>
    <div v-if="$store.state.step === 5" class="text-center">
      <h4>Processing your {{ video.myTitle }} Video</h4>
      <h6 class="secondary">
        Processing can take up to 30 seconds
      </h6>
      <div style="80%" @click.prevent="next()">
        <img class="mt-4" :src="this.spinner" width="100" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StepFive",
  props: ["step"],
  mounted() {},
  computed: {
    videos: {
      get() {
        return this.$store.state.videos[this.srcVid];
      },
    },
    video: {
      get() {
        return this.$store.state.srcVideos.find(
          (x) => x.id === this.$store.state.customization.srcVid
        );
      },
    },
  },
  data: function() {
    return {
      spinner: "https://i.imgur.com/j0N3EFB.png",
      srcVid: this.getSrcVid(),
    };
  },
  methods: {
    next() {
      this.$store.commit("changeStep", 6);
    },
    prev() {
      this.$store.commit("changeStep", 4);
    },
    getSrcVid() {
      return this.$store.state.customization.srcVid;
    },
  },
  watch: {
    videos: function(vals) {
      console.log("vals[0] " + vals[0]["render-status"]);
      if (vals[0]["render-status"] == "done") {
        //this.$store.state.customVideo = vals[0].customVideo;
        this.next();
      }
    },
  },
};
</script>
